<div class="modal-header">
  <h4 class="modal-title">Select Refund Amount</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <p>
    Total excess paid: <b>{{ orgConfig.getCurrencySymbol() }}{{ booking.amount_due.slice(1) }}</b>
  </p>

  <div class="form-group">
    <label for="amount">Amount to refund</label>
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
      </div>
      <input type="number" class="form-control" id="amount"
             min="0.01" step="0.01"
             [(ngModel)]="amount">
    </div>
  </div>

  <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Go Back
  </button>
  <button type="button" class="btn btn-primary"
          *ngIf="!loading"
          (click)="onSubmit()">
    Refund
  </button>
  <button type="button" class="btn btn-primary disabled" disabled
          *ngIf="loading">
    Loading...
  </button>
</div>
